"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const package_json_1 = __importDefault(require("../package.json"));
const { sha, static_path: staticPath } = window.summithill || {};
const devApiUrl = 'https://summithill-dev.azurewebsites.net/api/v1/';
const debug = {
    logrocket: null,
    sentry: {
        token: LOCAL_API ? '' : 'https://cfa524824885450c91b030f8ce0d4c92@o14401.ingest.sentry.io/6011067',
        environment: "dev"
    },
    staticPath: LOCAL_API
        ? '//127.0.0.1:8000/static'
        : 'https://summithill-dev.s3.amazonaws.com/static',
    API_URL: LOCAL_API ? 'http://127.0.0.1:8000/api/v1/' : devApiUrl,
    version: package_json_1.default.version,
    showsAPIBodies: true,
    stripePubKey: 'pk_test_51Jcx0rLKs5Bi0tRWfz7wdIMpcHcpp5LTE3W4psVB4edHPmNt4RxfdohptBpRoSRRSANeHFZOqbmHC8jpBpysLgOZ00fqWgQB3E'
};
const staging = {
    logrocket: {
        token: '',
        showReportingButton: true,
        sha,
    },
    sentry: LOCAL_API ? null : {
        token: 'https://cfa524824885450c91b030f8ce0d4c92@o14401.ingest.sentry.io/6011067',
        environment: "staging"
    },
    staticPath: staticPath ? staticPath.slice(0, -1) : '',
    API_URL: 'https://summithill-stg.azurewebsites.net/api/v1/',
    version: package_json_1.default.version,
    showsAPIBodies: false,
    stripePubKey: 'pk_test_51JiKalB9cr6ud45JQbdoLxNQT6CO12EguqCMG1U3mkhq0dlClbGq2x5LDd145UV1i9z6NO9LUCkTNoXnPfIWJj3B00uEqtnWw1'
};
const production = {
    logrocket: {
        token: '',
        showReportingButton: false,
        sha,
    },
    sentry: {
        token: 'https://cfa524824885450c91b030f8ce0d4c92@o14401.ingest.sentry.io/6011067',
        environment: "production"
    },
    staticPath: staticPath ? staticPath.slice(0, -1) : '',
    API_URL: 'https://summithill-prd.eastus.cloudapp.azure.com/api/v1/',
    showsAPIBodies: false,
    stripePubKey: 'pk_live_51JiKalB9cr6ud45Jd17KCsikSucKrkxAIS81zXGIYscMnqxrFkMo6RtwTezugaW1568w5dZFF74fL20Pze7luOhY00kRIGYtYw'
};
const configs = {
    debug,
    staging,
    production,
};
// @ts-ignore
const environment = configs[process.env.NODE_ENV || 'debug'];
if (!environment) {
    /* eslint-disable */
    console.error('No config file found.  Defaulting to debug');
    /* eslint-enable */
}
const config = environment || debug;
exports.default = config;
